const goodsList = [{
  title: '服饰/箱包',
  data: [{
      label: '卫衣',
      value: '卫衣'
    },
    {
      label: '羽绒服',
      value: '羽绒服'
    },
    {
      label: '外套',
      value: '外套'
    },
    {
      label: '运动鞋',
      value: '运动鞋'
    },
    {
      label: '拉杆箱',
      value: '拉杆箱'
    },
    {
      label: '皮带',
      value: '皮带'
    },
    {
      label: '帽子',
      value: '帽子'
    },
    {
      label: '衬衫',
      value: '衬衫'
    },
    {
      label: '袜子',
      value: '袜子'
    },
    {
      label: '皮包',
      value: '皮包'
    },
  ]
},
{
  title: '美妆/清洁',
  data: [{
      label: '眼霜',
      value: '眼霜'
    },
    {
      label: '面膜',
      value: '面膜'
    },
    {
      label: '口红',
      value: '口红'
    },
    {
      label: '沐浴露',
      value: '沐浴露'
    },
    {
      label: '香皂',
      value: '香皂'
    },
  ]
},
{
  title: '食品类',
  data: [{
      label: '零食',
      value: '零食'
    },
    {
      label: '水果',
      value: '水果'
    },
    {
      label: '面包',
      value: '面包'
    },
    {
      label: '酒水',
      value: '酒水'
    },
    {
      label: '茶叶',
      value: '茶叶'
    },
  ]
},
{
  title: '家居/生活',
  data: [{
      label: '纸巾',
      value: '纸巾'
    },
    {
      label: '蚕丝被',
      value: '蚕丝被'
    },
    {
      label: '四件套',
      value: '四件套'
    },
    {
      label: '厨具',
      value: '厨具'
    },
    {
      label: '洗衣液',
      value: '洗衣液'
    },
  ]
},
{
  title: '运动/娱乐',
  data: [{
      label: '椅子',
      value: '椅子'
    },
    {
      label: '瑜伽垫',
      value: '瑜伽垫'
    },
    {
      label: '篮球',
      value: '篮球'
    },
    {
      label: '玩具',
      value: '玩具'
    },
    {
      label: '吉他',
      value: '吉他'
    },
  ]
},
{
  title: '电器/数码',
  data: [{
      label: '耳机',
      value: '耳机'
    },
    {
      label: '充电宝',
      value: '充电宝'
    },
    {
      label: '手机',
      value: '手机'
    },
    {
      label: '音响',
      value: '音响'
    },
    {
      label: '剃须刀',
      value: '剃须刀'
    },
  ]
},
{
  title: '首饰/佩戴',
  data: [{
      label: '手链',
      value: '手链'
    },
    {
      label: '项链',
      value: '项链'
    },
    {
      label: '戒指',
      value: '戒指'
    },
    {
      label: '耳钉',
      value: '耳钉'
    },
    {
      label: '眼镜',
      value: '眼镜'
    },
  ]
},
]
const priceList = [{
label: '不限',
value: 0
},
{
label: '50元以下',
value: 1
},
{
label: '50-150元',
value: 2
},
{
label: '150-300元',
value: 3
},
{
label: '300元以上',
value: 4
},
]
export {
goodsList,
priceList
}